import './footer.css';

import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import React from 'react';

import logo from '../images/logo/intrepid.webp';

import propertiesService from '../service/properties-service';
import { usePageDynamicResults } from '../hooks/use-page-dynamic';

import siteData from '../data/site-data.yaml';

import { StaticImage } from 'gatsby-plugin-image';

const Footer = ({ reduced }) => {
  const data = usePageDynamicResults(['footer']);

  let first = true;

  const pageSort = (a, b) => {
    const propsA = propertiesService.getProperties(a);
    const propsB = propertiesService.getProperties(b);

    const sortProp = 'Footer Position';

    return parseInt(propsA[sortProp]) - parseInt(propsB[sortProp]);
  };

  return (
    <footer id="footer">
      <span className="footer-container">
        {!reduced ? (
          <span className="title-yellow">
            <Link to="/get-in-touch">Get in touch</Link>
          </span>
        ) : (
          ''
        )}

        {!reduced ? (
          <span className="address">
            {siteData.contact.address[0] +
              ', ' +
              siteData.contact.address[2] +
              ', ' +
              siteData.contact.address[3] +
              ', ' +
              siteData.contact.address[4] +
              ', ' +
              siteData.contact.post_code}
          </span>
        ) : (
          ''
        )}

        {!reduced ? (
          <span className="contact">
            <a href={'mailto:' + siteData.contact.email}>{siteData.contact.email}</a>
            <a href={'tel:' + siteData.contact.telephone}>{siteData.contact.telephone_pretty}</a>
          </span>
        ) : (
          ''
        )}

        <span className="social">
          <a href="https://www.instagram.com/intrepidltd/">
            <StaticImage width="30px" height="30px" alt="Instagram" src="../images/icons/instagram.webp" />
          </a>
          <a href="https://uk.linkedin.com/company/pivot-engine">
            <StaticImage width="30px" height="30px" alt="LinkedIn" src="../images/icons/linkedin.webp" />
          </a>
        </span>

        <span className="navigation">
          <span className="left-item">
            <Link to="/">
              <img width="150px" alt="Intrepid Logo" src={logo} />
            </Link>
          </span>
          <span className="center-item">
            {data.sort(pageSort).map((edge) => {
              let separator = '';
              if (first) {
                first = false;
              } else {
                separator = ' | ';
              }

              const props = propertiesService.getProperties(edge);
              const title = props['External Name'] ? props['External Name'] : edge.node.title;

              return (
                <span key={edge.node.slug}>
                  {separator}
                  <Link to={'/' + edge.node.slug}>{title}</Link>
                </span>
              );
            })}
          </span>

          <span className="right-item">© {new Date().getFullYear()} Intrepid Ltd. All rights reserved.</span>
        </span>
      </span>
    </footer>
  );
};

Footer.propTypes = {
  reduced: PropTypes.bool,
};

Footer.defaultProps = {
  reduced: false,
};

export default Footer;
